/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsUpDown = createReactComponent("arrows-up-down", "IconArrowsUpDown", [
  ["path", { d: "M7 3l0 18", key: "svg-0" }],
  ["path", { d: "M10 6l-3 -3l-3 3", key: "svg-1" }],
  ["path", { d: "M20 18l-3 3l-3 -3", key: "svg-2" }],
  ["path", { d: "M17 21l0 -18", key: "svg-3" }]
]);

export { IconArrowsUpDown as default };
//# sourceMappingURL=IconArrowsUpDown.js.map
